import { Component, ViewChild, Input, Output, OnChanges, EventEmitter  } from '@angular/core';
import { TranslateService, TranslatePipe, LangChangeEvent } from '@ngx-translate/core';
import { GlobalVariables } from '../../../../../../common/global-variables';
let $ = require('jquery');
import { Service } from './connect-network.service';
import { VcaAlertsService } from '../../../../../../common/vca-alerts/vca-alerts.service';

@Component({
  selector: 'disconnect-gateway',
  styles: [require('../../direct-connect.scss')],
  template: require('./disconnect-gateway.html'),
   providers: [
    TranslateService, Service
  ]
})

export class DisconnectGatewayDialog {
  @Input() createData: any;
  @Input() isDialogOpen: boolean = false;
  @Output('onClose') selfClose = new EventEmitter();

  private directConnectName: string = '';
  private edgeName: string = '';
  private subscribeHandler;
  private loading: boolean = false;

  constructor(public service: Service, private translate: TranslateService, private alert: VcaAlertsService) {
      translate.use(GlobalVariables.LOCALE);
  }

  onSubmitButtonClicked() {
    this.loading = true;
    let _thisVar = this;
    let data = {
        'edgeId': this.createData.edge.id,
        'edgeName': this.createData.edge.name,
        'uplinksPayload': []
    }

    let networkList = this.createData.edge;
    if (networkList.gatewayInterfaces && networkList.gatewayInterfaces.length > 0) {
      networkList.gatewayInterfaces.map(function(networks, index) {
        if (data['uplinks'] && (data['uplinks'] == networks.networkId)) {
          networks.defaultRoute = true;
          networks.operation = "modify";
          data['uplinksPayload'].push(networks);
        }
        if (_thisVar.createData.rowData.network.id == networks.networkId) {
            networks.operation = "delete";
            networks.defaultRoute = false;
            data['uplinksPayload'].push(networks);
        }
      });
    }
    let obj = { "uplinks": data['uplinksPayload'] };
    this.subscribeHandler = this.service.updateUplinksOfEdge(obj, data.edgeId)
        .subscribe(
          res => {
              this.loading = false
              this.closeSelf();
          },
          error => {
              this.loading = false;
              this.alert.danger(['Operation Failed. Please try again', error], 'disconnect-gateway-dialog');
          },
          () => {
              this.service.logOperationCompleted('Connect Network to DirectConnect')
          }
        )
  }

  onCancelButtonClicked() {
    this.closeSelf();
  }

  ngOnChanges(changes) {
      if (this.createData && this.isDialogOpen) {
          this.directConnectName = this.createData.directConnectName;
          this.edgeName = this.createData.edgeName;
      }
  }

  ngOnDestroy() {
    if (this.subscribeHandler) this.subscribeHandler.unsubscribe();
  }

  closeSelf() {
    if (this.selfClose) {
      this.selfClose.emit({
        value: 'close'
      });
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/components/network/direct-connect/dialog/connect-network/disconnect-gateway.component.ts